import React, { memo, useState } from 'react';

import { Button } from 'reactstrap';

import Modal from './Modal';

import util from '~/assets/util';

function ImportProductsButton(props) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button {...props} color="primary" outline type="button" onClick={() => setShowModal(true)}>
        {util.t('IMPORT_PRODUCTS')}
      </Button>

      <Modal isOpen={showModal} unmountOnClose toggle={() => setShowModal(false)} />
    </>
  );
}

export default memo(ImportProductsButton);
